<!-- /**
* 工队-工人详情页面
* @date 2020/7/16
* @version 1.2.1
*/ -->
<template>
  <div class="workerDetail_page">
    <div
      class="leftBox"
      v-loading="loadingTrue"
      element-loading-background="rgba(255, 255, 255, 1)"
    >
      <div class="worker_text">
        <div class="right_con">
          <div class="fx">
            <img width="16px" height="16px" src="@/assets/team/liulan.png" alt="" />
            <p style="color:#969696">浏览<span class="num">{{workerDetail.count ? workerDetail.count : "0"}}</span>次</p>
          </div>
          <div class="lianxi fx" style="display: none">
            <img width="16px" height="16px" src="@/assets/team/lianxi.png" alt=""/>
            <p>联系<span class="num">{{workerDetail.contactCount ? workerDetail.contactCount : "0"}}</span>次</p>
          </div>
        </div>
        <div class="top_title">
          <div class="leftT">
            <div class="pics">
              <img
                v-if="!workerDetail.avatarAddress"
                src="@/assets/public/gebilaowang.png"
                alt=""
              />
              <img v-else :src="workerDetail.avatarAddress" alt="" />
            </div>
            <div class="content">
              <div class="item_text">
                <div class="text_title" style="margin-right:10px">{{ workerDetail.name }}</div>
                <div class="item_age" style="marginleft: 10px">
                  {{ workerDetail.age ? workerDetail.age + "岁" : "" }}
                </div>
                <div v-if="workerDetail.nationName" class="line">|</div>
                <div style="marginright: 10px" v-if="workerDetail.nationName">
                  {{ workerDetail.nationName }}
                </div>
                <div class="sex">
                  <img
                    style="width:14px;height:14px"
                    v-if="workerDetail.sex == 0"
                    src="@/assets/worker/sex.png"
                    alt=""
                  />
                  <img style="width:14px;height:14px" v-else src="@/assets/worker/sexx.png" alt="" />
                </div>
                <div class="work_state" v-if="workerDetail.workStatus">
                  工作中
                </div>
                <div class="work_state" v-else>休息中</div>
                <div class="RealName" v-if="workerDetail.identity">已实名</div>
              </div>
              <div class="certificate_box" style=""  v-for="(item, index) in certificateLists" :key="index" >
                <div style="display: flex;align-items: center;">
                  <img style="width:22px;height:23px" src="@/assets/worker/zgzs.png" alt="">
                  <span :name="item.workName" @mouseover="eventFn(true,item)" @mouseout="eventFn(false,item)"  class="certificate_icon">证</span>
                  <span class="workName_class" v-if="isShowZs&&zsName[0].no==item.no">{{zsName[0].workName||''}}</span>
                </div>
              </div>
              <div class="senced_text">
                <div class="three_text">
                  <div
                    class="evaluate"
                    v-for="(item, index) in workerDetail.labelName"
                    :key="index"
                  >
                    {{ item }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="item_time">
            <div class="workerYaer">
              <img src="@/assets/worker/wkIcon.png" alt="" />
              <span>
                工龄
                <b>{{ workerDetail.workYear }}</b>
                年
              </span>
            </div>
            <div class="workerYaer">
              <img src="@/assets/worker/zjIcon.png" alt="" />
              <span>{{ workerDetail.proficiencyName }}</span>
            </div>
          </div>
        </div>
        <div class="worker_body">
          <div>
            <el-row :gutter="20">
              <el-col :span="8">
                <div class="item_texts" style="padding-bottom:0">
                  <span class="item_icon">
                    <img style="width:24px;height:24px" src="@/assets/worker/gongzhong1.png" alt="" />
                  </span>
                  <span style="min-width:70px">工作领域：</span>
                  <div @mouseenter="handleShowTooltip($event)">
                    <el-tooltip popper-class="popperCustoms" :visible-arrow="false" :disabled="showTooltip"  placement="bottom" class="single_hide" effect="light">
                      <div class="color3 single_hide" style="color: #333;max-width:256px">{{ workerDetail|getIndustryName}}</div>
                      <div slot="content"  style="color: #666;">{{ workerDetail|getIndustryName}}</div>
                    </el-tooltip>
                  </div>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="item_texts" style="padding-bottom:0">
                  <span class="item_icon">
                    <img style="width:24px;height:24px" src="@/assets/worker/gongzhong1.png" alt="" />
                  </span>
                  <span style="min-width:70px">专业技术：</span>
                  <div @mouseenter="handleShowTooltip($event)">
                    <el-tooltip popper-class="popperCustoms" :visible-arrow="false" :disabled="showTooltip"  placement="bottom" class="single_hide" effect="light">
                      <div class="color3 single_hide" style="color: #333;max-width:256px">{{ workerDetail|getWorkTypeName}}</div>
                      <div slot="content"  style="color: #666;">{{ workerDetail|getWorkTypeName}}</div>
                    </el-tooltip>
                  </div>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="item_text single_hide" style="padding-bottom:0">
                  <span class="item_icon">
                    <img style="width:24px;height:24px" src="@/assets/worker/jiguan.png" alt="" />
                  </span>
                  <span>户籍地址：</span>
                  <span class="item_tag color3">
                    {{ workerDetail.legalAddressAll?workerDetail.legalAddressAll:"暂未填写" }}
                  </span>
                </div>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="8">
                <div class="item_text" >
                  <span class="item_icon">
                    <img style="width:24px;height:24px" src="@/assets/worker/gongzuo.png" alt="" />
                  </span>
                  <span style="vertical-align: super">工作区域：</span>
                  <div @mouseenter="handleShowTooltip($event)">
                    <el-tooltip popper-class="popperCustoms" :visible-arrow="false" :disabled="showTooltip"  placement="bottom" class="single_hide" effect="light">
                      <div class="color3 single_hide" style="color: #333;max-width:256px">{{ workerDetail.workAreaName}}</div>
                      <div slot="content"  style="color: #666;">{{ workerDetail.workAreaName}}</div>
                    </el-tooltip>
                  </div>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="item_text single_hide">
                  <span class="item_icon">
                    <img style="width:24px;height:24px" src="@/assets/worker/dingwei.png" alt="" />
                  </span>
                  <span>所在地区：</span>
                  <span class="item_tag color3">
                    {{ workerDetail.addressAll ? workerDetail.addressAll : "/" }}
                  </span>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="item_text single_hide">
                  <span class="item_icon">
                    <img style="width:24px;height:24px" src="@/assets/worker/dianhua.png" alt="" />
                  </span>
                  <span>联系电话：</span>
                  <span
                    class="item_tag single_hide color3"
                    v-if="workerDetail.contactPhone && !isCanLookPhone"
                  >
                    {{ starPhone(workerDetail.contactPhone) }}
                  </span>
                  <span v-if="workerDetail.contactPhone && isCanLookPhone">
                    {{ workerDetail.contactPhone }}
                  </span>
                  <span
                    v-if="workerDetail.contactPhone && !isCanLookPhone"
                    @click="queryContactType"
                    class="query-phone"
                    style="
                      color: #0286df;
                      margin-left: 14px;
                      cursor: pointer;
                      font-size:14px
                    "
                  >
                    查看联系电话
                  </span>
                </div>
              </el-col>
            </el-row>

            <el-row
              v-if="
                workerDetail &&
                workerDetail.healthImg &&
                workerDetail.healthImg.length
              "
            >
              <el-col :span="12">
                <div
                  class="item_text single_hide"
                  style="display: block; padding-top: 0px;padding-bottom:15px"
                >
                  <span class="item_icon">
                    <img style="width:24px;height:24px" src="@/assets/worker/jiankang1.png" alt="" />
                  </span>
                  <span style="vertical-align: super">健康证明：</span>
                  <span class="item_tag color3 work_scope">
                    <el-image
                      style="width: 80px; height: 80px; margin-right: 10px"
                      v-for="item in workerDetail.healthImg"
                      :key="item"
                      :preview-src-list="[item]"
                      :src="item"
                      fit="cover"
                    ></el-image>
                  </span>
                </div>
              </el-col>
            </el-row>
          </div>
          <div>
          <btns
            style="padding-top:5px"
            :item="workerDetail"
            :type="3"
            @end="iniData"
            @changeStatus="v => (state = v)"
          ></btns>
        </div>
          <div class="top-text">
            <div class="tips" style="margin-top:0px">联系时，请说明是在“经营帮”上看到的</div>
            <div class="ls" style="margin-top:0px">
              <span v-if="workerDetail.updateTime===workerDetail.createTime" style="color:#666">{{workerDetail.createTime | formatDate}}发布</span>
              <span v-else style="color:#666">{{workerDetail.updateTime | formatDate}}更新</span>
            </div>
          </div>
        </div>
      </div>
      <div class="workerDetail_tab">
        <el-tabs v-model="activename" @tab-click="handleClick" id="pane">
          <el-tab-pane label="自我介绍" activeIndex="0">
            <div v-if="workerDetail.introduce||(workerDetail.customFieldList&&workerDetail.customFieldList.length)||(workerDetail.fileList&&workerDetail.fileList.length)">
            <div class="experience">
            <div v-if="workerDetail.introduce" >
              <span style="color:#666">自我介绍：</span> 
              <span class="color3">{{ workerDetail.introduce }}</span>
            </div>
            <el-row  v-if="workerDetail.customFieldList&&workerDetail.customFieldList.length">
              <el-col :span="24" class="detail-item" v-for="(field,index) in workerDetail.customFieldList" :key="index">
                <span class="item-name">{{ field.title }}：</span>
                <span class="item-value">{{ field.value }}</span>
              </el-col>
            </el-row>
            <el-row v-if="workerDetail.fileList&&workerDetail.fileList.length" :gutter="20" class="itemRow">
              <el-col
              :span="24"
              class="detail-item"
              v-if="workerDetail.fileList&&workerDetail.fileList.length"
            >
                <span style="" class="item-name">附件：</span>
                <span style="display: flex; flex-wrap: wrap">
                  <div
                    v-for="(file, index) in workerDetail.fileList"
                    :key="index"
                    class="file-item"
                  >
                    <div class="file-item-container" :style="workerDetail.fileList.length>4?'margin-bottom:10px':'margin-bottom:0px'">
                      <img
                        :src="fileIcon[file.name.split('.').pop().toLowerCase()]"
                        alt=""
                        class="file-icon"
                      />
                      <div class="file-info">
                        <div class="file-name">
                          <div class="fore">
                            {{
                              file.name.slice(0, file.name.lastIndexOf("."))
                            }}
                          </div>
                          <div class="back">
                            .{{ file.name.split(".").pop() }}
                          </div>
                        </div>
                        <div class="file-other">
                          <span class="file-size">{{
                            formatFileSize(file.size)
                          }}</span>
                          <span
                            class="file-download"
                            @click="$previewFile(file.fileUrl)"
                            >预览</span
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </span>
              </el-col>
            </el-row>
            </div>
            </div>
            <BaseEmptyData
              isDetail
              v-if="!workerDetail.introduce&&!(workerDetail.customFieldList&&workerDetail.customFieldList.length)&&!(workerDetail.fileList&&workerDetail.fileList.length)&& !loadingTrue"
            ></BaseEmptyData>
          </el-tab-pane>
          <el-tab-pane label="工作业绩" activeIndex="1">
            <div  v-if="workerDetail.list&&workerDetail.list.length">
              <div
                class="experience"
                v-for="(item, index) in workerDetail.list"
                :key="index"
              >
                <div class="item_experience">
                  <h3>{{ item.projectName }}</h3>
                  <div class="item_adres">
                    <div class="timer">
                      {{ item.startTime ? dateFormat(item.startTime) + "~" : ""
                      }}{{ dateFormat(item.endTime) }}
                    </div>
                  </div>
                  <div style="fontsize: 14px; margin-bottom: 10px">
                    {{ item.provinceName }}{{ item.cityName
                    }}{{ item.areaName }}
                  </div>
                  <el-row :gutter="20">
                    <el-col>
                      <div class="item_flex" v-if="item.content">
                        <div class="flex_title" style="min-width:70px">
                          <span style="color:#666">工作介绍：</span>
                        </div>
                        <div class="item_tag">
                          <span style="word-break:break-all">{{ item.content }}</span>
                        </div>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row v-if="item.workFieldList&&item.workFieldList.length" style="margin-bottom:10px">
                    <el-col :span="24" class="detail-item" v-for="(field,index) in item.workFieldList" :key="index">
                      <span class="item-name">{{ field.name }}：</span>
                      <span class="item-value">{{ field.content }}</span>
                    </el-col>
                  </el-row>
                  <el-row
                    style="margin-top: 10px"
                    :gutter="20"
                    v-if="item.filePath.length"
                  >
                    <el-col>
                      <div class="item_flex">
                        <div class="flex_title">
                          <span style="color:#666">工作图片：</span>
                        </div>
                        <el-image
                          fit="cover"
                          class="item_pic"
                          v-for="(item, index) in item.filePath"
                          :key="index"
                          :src="item"
                          :preview-src-list="[item]"
                        ></el-image>
                      </div>
                    </el-col>
                  </el-row>
                </div>
              </div>
            </div>
            <BaseEmptyData
              isDetail
              v-if="!(workerDetail.list&&workerDetail.list.length) && !loadingTrue"
            ></BaseEmptyData>
          </el-tab-pane>
          <el-tab-pane label="个人风采" activeIndex="4">
            <personalStyleList :data='workerDetail.personalStyleList'></personalStyleList>
          </el-tab-pane>
          <el-tab-pane label="资格证书" activeIndex="2">
            <qualification :data='workerDetail.filePath' :newData='certificateList'></qualification>
          </el-tab-pane>
          <el-tab-pane label="荣誉证书" activeIndex="3">
            <honor :data='workerDetail.certificateOfHonorList'></honor>
          </el-tab-pane>
          <el-tab-pane label="个人资产" activeIndex="5">
            <personalAssetsList :sbData='sbData' :clData='clData'></personalAssetsList>
          </el-tab-pane>
        </el-tabs>
      </div>
      <!-- 推荐列表 -->
      <div class="recommendList" >
        <div class="title">
          <div class="name">相关工人推荐</div>
          <div
            class="more"
            @click="
              $router.replace('/worker')
              reload()
            "
          >
            查看更多
            <img src="@/assets/teamIcon/more.png" alt="" />
          </div>
        </div>

        <div>
          <el-row
            style="padding: 0px 20px 20px"
            :gutter="20"
            v-if="recommendedList.length"
          >
            <el-col
              v-for="(item, index) in recommendedList"
              :span="12"
              :key="index"
            >
              <card :item="item" :type="3"></card>
            </el-col>
          </el-row>
        </div>

        <BaseEmptyData
          isDetail
          v-if="!recommendedList.length && !loadingTrue"
        ></BaseEmptyData>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "@/http"
import { apiWorker } from "@/api/apiWorker"
import { apiResignAll } from "@/api/apiResignAll"
import link from "@/public/link.js"
import { formatDate2, NextDateTime } from "@/filters"
import { mapState } from "vuex"
import cookie from "@/storage/cookies.js"
import { api } from "@/api/apiRecommendedList"
import '@/utils/previewFile'//预览文件
const ERR_OK = 200 // 分页
export default {
  name: "workerDetail",
  inject: ["reload"], // 引入App.vue 中的刷新页面的方法
  props: {},
  data() {
    return {
      isShowZs:false,
      zsName:'',
      sbData:[],
      clData:[],
      industryName:'',
      workTypeNames:'',
      showTooltip:false,
      fileIcon: {
        jpg: require("@/assets/fileIcon/image.png"),
        jpeg: require("@/assets/fileIcon/image.png"),
        png: require("@/assets/fileIcon/image.png"),
        pdf: require("@/assets/fileIcon/pdf.png"),
        zip: require("@/assets/fileIcon/zip.png"),
        rar: require("@/assets/fileIcon/zip.png"),
        doc: require("@/assets/fileIcon/word.png"),
        docx: require("@/assets/fileIcon/word.png"),
        xlsx: require("@/assets/fileIcon/xls.png"),
        xls: require("@/assets/fileIcon/xls.png")
      },
      activename: "0",
      recommendList: [],
      healthImg: [],
      type: "",
      evaluate: ["吃苦耐劳", "优质服务", "高效完成"],
      // 是否关注
      isAttention: false,
      dialogFormVisible: false,
      workerDetail: {},
      projectDetail: [],
      imgList: [],
      mapCenter: [],
      mapPosition: [],
      text: {
        text: "",
        offset: [0, -50]
      },
      checkIndex: 0,
      phone: "",
      title: {
        name: "",
        updateTime: null
      },
      tab: [
        {
          name: "工程详情",
          show: true
        },
        {
          name: "团队要求",
          show: true
        }
      ],
      constructionTeamData: {},
      rollScroll: false,
      performanceParam: {
        page: 1,
        limit: 20
      },
      loadingTrue: false,
      engineeringInfoVO: {},
      isCanLookPhone: false,
      param: {
        pageNum: 1,
        pageSize: 6,
        // provinceNo: JSON.parse(cookie.cookieRead("area")).id
      },
      recommendedList: [],
      certificateList: [],
      certificateLists: []
    }
  },
  components: {
    btns: () => import("@/components/details/btns"), // 按钮组
    BaseEmptyData: () => import("@/components/public/BaseEmptyData"), // 暂无数据缺省图
    card: () => import("@/components/card/cardWorkerList.vue"), 
    honor: () => import("./comppnents/honor.vue"), 
    qualification: () => import("./comppnents/qualification.vue"), 
    personalStyleList: () => import("./comppnents/personalStyleList.vue"), 
    personalAssetsList: () => import("./comppnents/personalAssetsList.vue") 
  },
  watch: {
    hasToken: {
      handler(n, o) {
        // this.iniData(this.$route.query.teamNo);
        // let token = this.$store.state.token;
        // if (token) {
        //   this.iniData({ no: this.$route.query.no ? this.$route.query.no : null, type: "2" });
        // } else {
        //  this.innoata({ no: this.$route.query.no ? this.$route.query.no : null});
        // }
      },
      immediate: true
    }
  },
  computed: {
    ...mapState({
      workerIndex: state => state.workerIndex,
      loginType: state => state.loginType
    }),
    hasToken() {
      return this.$store.state.token
    }
  },
  created() {},
  mounted() {
    // if (this.loginType) {
    //   this.userFocus()
    // }
    // window.addEventListener("scroll", this.menu)
    if (this.$route.query.no) {
      if (this.loginType) {
        this.type = "2"
      } else {
        this.type = ""
      }
    }
      this.iniData(this.$route.query.no,this.type)
  },
  methods: {
    eventFn(type,data){
      this.zsName=this.certificateList.filter(i=>{
        return i.no==data.no
      })
      this.isShowZs=type?true:false
    },
    //内容超出时,hover显示所有文本信息
    handleShowTooltip(event){
      let cell = event.target.querySelector('.el-tooltip');
      this.showTooltip = cell.scrollWidth === cell.offsetWidth;
    },
    /**
     * 格式化页面显示的文件大小
     * @param fileSize 文件大小
     */
    formatFileSize(fileSize = 0) {
      fileSize = Number(fileSize)
      if (fileSize /1024 > 10) {
        return `${(fileSize /1024).toFixed(2)}M`
      } else {
        return `${Math.ceil(fileSize)}kb`
      }
    },
    NextDateTime,
    showMap() {
      this.dialogFormVisible = true
    },
    // 隐藏号码中间4位数
    starPhone(phoneNum) {
      let str = String(phoneNum)
      return str.substr(0, 3) + "****" + str.substr(7)
    },
    /**
     * @name 点击关注
     * @type 工队1 工程2 工人3 */
    // clickAttention(state) {
    //   let token = this.$store.state.token
    //   if (!token) {
    //     let data = {
    //       callBack: function () {
    //         this.$store.dispatch("setUser")
    //       }.bind(this)
    //     }
    //     this.$_login(data)
    //   } else {
    //     let no = this.$route.query.no
    //     let type = 3
    //     this.isAttention = state
    //     if (this.isRepeatSubmit) return
    //     this.isRepeatSubmit = true
    //     apiResignAll
    //       .addAttention(no, type, this.isAttention)
    //       .then(res => {
    //         if (res.data && res.data.code === 200) {
    //           this.$message.success(res.data.data)
    //           this.userFocus()
    //         } else {
    //           this.$message.error(res.data.data)
    //         }
    //       })
    //       .finally(() => {
    //         this.isRepeatSubmit = false
    //       })
    //   }
    // },
    /** @name 获取是否关注 */
    // userFocus() {
    //   let no = this.$route.query.no
    //   let type = 3
    //   apiResignAll.userFocus(no, type).then(res => {
    //     if (res.data.code === 200) {
    //       this.isAttention = res.data.data
    //     }
    //   })
    // },
    /** @name 在线咨询 */
    OnlineConsulting() {
      if (this.$store.state.loginType) {
        if (this.workerDetail.imId) {
          axios
            .get(
              process.env.VUE_APP_APITEAM +
                "/consultation?id=" +
                this.workerDetail.imId
            )
            .then(res => {
              if (res.data.code === ERR_OK) {
                this.$store.commit("SET_ISOPEN", true)
                this.$store.commit("SETTOUSER", res.data.data.imAccount)
              } else {
                this.$message.error(res.data.msg)
              }
            })
        } else {
          this.$message.error("未设置客服人员，不支持咨询！")
        }
      } else {
        this.loginIndex()
      }
    },

    loginIndex() {
      let data = {
        callBack: function () {
          this.$store.dispatch("setUser")
          this.pushThis()
        }.bind(this)
      }
      this.$_login(data)
    },
    formatDate2,
    checkContactway() {
      if (this.$store.state.loginType) {
        this.constructionTeamData.concatPhone = this.phone
      } else {
        link.login()
        //   this.$confirm('当前未登录, 是否跳转到登录页面?', '提示', {
        //     confirmButtonText: '确定',
        //     cancelButtonText: '取消',
        //     type: 'warning'
        //   }).then(() => {
        //     window.location.href = process.env.VUE_APP_DOMAIN +'/login'
        //   })
      }
    },
    // 获取详情数据
    async iniData(no, type) {
      this.loadingTrue = true
      if (this.loginType) {
        type = "2"
      } else {
        type = ""
      }
      let res = await apiWorker.getWorkerDetail(no, type)
      if (res.data && res.data.code === 200) {
        this.workerDetail = res.data.data
        if (this.workerDetail.isFocus) {
          this.isAttention = true
        } else {
          this.isAttention = false
        }
        this.projectDetail = res.data.data.list
        this.imgList = this.workerDetail.filePath
        this.healthImg = this.workerDetail.healthImg
        //处理个人资产
        if(this.workerDetail.personalAssetsList&&this.workerDetail.personalAssetsList.length){
          this.workerDetail.personalAssetsList.map(i => {
            if (i.type == 0) {
              this.sbData.push(i)
            } else if (i.type == 1) {
              this.clData.push(i)
            }
          })
        }
        //处理资格证书 2.4.0
        if(this.workerDetail.certificateList&&this.workerDetail.certificateList.length){
          this.certificateList=this.workerDetail.certificateList.filter(i => {
           return i.auditStatus==1
          })
          if(this.certificateList.length>2){
            this.certificateLists=[this.certificateList[0],this.certificateList[1]]
          }else{
            this.certificateLists=this.certificateList
          }
        }
      }
      this.loadingTrue = false
      this.getRecommendedList()
    },
    check(index) {
      this.checkIndex = index
    },
    changeRollScroll(bol) {
      this.rollScroll = bol
    },
    menu() {},
    getShowTab() {},
    // 点击'查看联系方式'按钮
    queryContactType() {
      let token = this.$store.state.token
      if (!token) {
        this.loginIndex()
      } else {
        this.isCanLookPhone = true
        // this.updatePhoneCount()
      }
    },
    /**
     * 获取推荐列表
     */
    async getRecommendedList() {
      this.loadingTrue = true
      const { workType, no: workerNo, provinceNo } = this.workerDetail
      const params = {
        workType: workType && workType[0], // 工种编号第一个
        provinceNo, // 省编号
        workerNo // 当前专业工人no
      }
      const res = await api.getWorkerRecommend(params)
      if (res.data.code === 200) {
        this.recommendedList = res.data.data.slice(0, 6)
      } else {
        this.$message.error("系统异常，请稍后再试")
        this.recommendedList = []
      }
      this.loadingTrue = false
    },
    getList() {
      this.getRecommendedList()
    }
  },
  filters:{
    getIndustryName(info){
      if(info.firstThirdNoList && info.firstThirdNoList.length){
        return  info.firstThirdNoList.map(v=> v.industryName).join(' | ')
      }else if(info.industryName){
        return info.industryName
      }else{
        return '/'
      }
    },
    getWorkTypeName(info,flag){
      if(info.firstThirdNoList && info.firstThirdNoList.length){
        return  info.firstThirdNoList.map(v=> v.workTypeNames).join(' | ')
      }else if(info.workTypeName){
        return info.workTypeName
      }else{
        return  '/'
      }
    }
  },
  destroyed() {
    window.removeEventListener("scroll", this.menu)
  },
  provide() {
    return {
      cardListCom: this
    }
  }
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
div {
  box-sizing: border-box;
}
.workerDetail_page {
  padding: 10px 0;
  width: 1200px;
  font-size: 14px;
  color: #333;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  .leftBox {
    width: 100%;
    .worker_text {
      position: relative;
      background: #fff;
      border:1px solid #e4e7ed ;
      .right_con{
        position: absolute;
        top: 5px;
        right: 10px;
        .fx {
          display: flex;
          align-items: center;
          img {
            margin-right: 5px;
          }
          .num {
            color: #333;
            padding: 0 5px;
          }
        }
        .ls {
          display: flex;
          margin-top: 10px;
          .lianxi {
            margin: 0 10px;
          }
        }
      }
      .top_title {
        display: flex;
        justify-content: space-between;
        padding: 20px 10px 0 15px;
        .leftT {
          display: flex;
          .pics {
            width: 60px;
            height: 60px;
            margin-right: 10px;
            img {
              width: 100%;
              height: 100%;
              border-radius: 6px;
              margin-top: -5px;
            }
          }
          .content {
            .item_text {
              height: 25px;
              display: flex;
              justify-content: flex-start;
              align-items: center;
              .text_title {
                font-size: 24px;
                font-weight: bold;
              }
              .line {
                margin: 0 10px;
              }
              .sex {
                margin:2px 0 0 10px;
              }
              .RealName {
                width: 53px;
                height: 20px;
                background: rgba(120, 192, 110, 0.1);
                border-radius: 2px;
                color: #78c06e;
                font-size: 14px;
                text-align: center;
                line-height: 20px;
              }
            }
            .certificate_box{
              position: relative;
              margin-top:8px;
              display:inline-block;
              margin-right:10px;
              .workName_class{
                color: #666;
                font-size: 14px;
                margin-left: 4px;
              }
              .certificate_icon{
                position: absolute;
                top: 4px;
                left: 4px;
                font-size:12px;
                cursor: pointer;
                color:#F7AB01;
              }
            }
            .senced_text {
              padding-top: 8px;
              .line {
                margin: 0 10px;
              }
              .three_text {
                display: flex;
                color: #409ee9;
                font-size: 12px;
                .evaluate {
                  width: 56px;
                  height: 20px;
                  line-height: 18px;
                  margin-right: 5px;
                  border: 1px solid #0286df;
                  text-align: center;
                  border-radius: 4px;
                  color: #0286df;
                }
              }
            }
          }
        }
        .item_time {
          display: flex;
          align-items: center;
          .workerYaer {
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 20px;
            img {
              width: 28px;
              height: 28px;
              margin-right: 10px;
            }
            b {
              font-size: 20px;
              padding: 0 5px;
            }
          }
        }
      }
      .worker_body {
        // margin-top: 10px;
        padding: 0 20px;
        .single_hide {
          // 单行隐藏
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .color3 {
          color: #333333;
        }
        .item_text {
          font-size: 14px;
          font-weight: 400;
          color: #666666;
          display: flex;
          align-items: center;
          padding: 15px 0;
          .color3 {
            color: #333333;
          }
          .item_icon {
            width: 24px;
            height: 24px;
            padding: 0 10px 0 0px;
          }
        }
        .item_texts {
          font-size: 14px;
          font-weight: 400;
          color: #666666;
          display: flex;
          align-items:center;
          padding: 15px 0;
          .color3 {
            color: #333333;
          }
          .item_icon {
            width: 24px;
            height: 24px;
            padding: 0 10px 0 0px;
          }
        }
        .top-text {
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 14px;
          color: #969696;
          border-top: 1px dashed #e4e7ed;
          height: 35px;
          line-height: 35px;
        }
      }
    }
    .workerDetail_tab {
      margin-top: 10px;
      background-color: #fff;
      border:1px solid #e4e7ed ;
      .experience {
        padding: 15px 20px;
        background: #F5F7FA;
        margin-bottom: 10px;
        &:last-child{
          margin-bottom: 0;
        }
        .item_experience {
          .item_adres {
            display: flex;
            padding-bottom: 10px;
            .timer {
              font-size: 16px;
              // font-weight: bold;
            }
          }
        }
        .item_flex {
          display: flex;
          line-height: 22px;
          .flex_title {
            width: 70px;
          }
          .item_tag {
            flex: 1;
          }
          .item_pic {
            margin-right: 10px;
            width: 80px;
            height: 80px;
            img {
              width: 100%;
              height: 100%;
            }
          }
        }
      }
      .experiences {
        padding: 15px 20px;
        background: #F5F7FA;
        margin-bottom: 10px;
        .item_experience {
          .item_adres {
            display: flex;
            padding-bottom: 10px;
            .timer {
              font-size: 16px;
              // font-weight: bold;
            }
          }
        }
        .item_flex {
          display: flex;
          line-height: 22px;
          .flex_title {
            width: 70px;
          }
          .item_tag {
            flex: 1;
          }
          .item_pic {
            margin-right: 10px;
            width: 80px;
            height: 80px;
            img {
              width: 100%;
              height: 100%;
            }
          }
        }
      }
      /deep/ .el-table {
        border: solid 1px #e4e7ed;
        border-bottom: none;
      }
      /deep/ .el-tabs__item {
        position: relative;
        &:not(:last-child):before {
          content: "";
          display: inline-block;
          height: 24px;
          border-left: 1px solid #e4e7ed;
          position: absolute;
          right: 0;
          top: 8px;
        }
      }
      /deep/ .el-tabs__item.is-active {
        color: #b79255;
        font-weight: 700;
      }
      /deep/ .el-tabs__item:hover {
        color: #b79255;
      }
      /deep/ .el-tabs {
        .el-tabs__nav-scroll {
          padding-left: 20px;
        }
        .el-tabs__header {
          margin: 0;
        }
        .el-tabs__active-bar {
          background-color: #b79255;
        }
        .el-tabs__content {
          padding: 15px 20px;
        }
        .el-tabs__nav-wrap::after {
          height: 1px;
        }
      }
    }
  }
  
  .rightBox {
    width: 300px;
    padding-left: 19px;
    .right_title {
      padding: 10px 10px;
      background-color: #fff;
      .name {
        font-size: 18px;
        font-weight: 400;
        line-height: 23px;
        border-left: 3px solid #0286df;
        padding-left: 10px;
        color: #0286df;
      }
    }
    .recommend {
      background-color: #fff;
      padding: 5px 10px;
      border-bottom: 1px solid #eee;
      .recommend_item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 5px 0;
        .gcName {
          width: 150px;
          color: #333;
          font-size: 14px;
          // 单行隐藏
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .gcTimer {
          // flex: 1;
          color: #969696;
          font-size: 14px;
        }
      }
    }
  }
  .work_scope {
    white-space: normal;
    display: inline-block;
    // width: 384px;
    vertical-align: text-top;
    margin-top: -5px;
  }
  .work_state {
    width: 48px;
    height: 20px;
    line-height: 1;
    font-size: 12px;
    margin-left: 8px;
    padding:4px 5px;
    color: #0286df;
    border-radius: 2px;
    background-color: #d9edfa;
  }
  /deep/.empty-data {
  width: 100%;
  background-color: white;
  .nodata,
  .empty {
    margin: 0 auto;
    .imgs {
      display: block;
      margin: 0 auto;
      width: 100px;
      height: 100px;
    }
    .message {
      margin-top: 10px;
      color: #666666;
      font-size: 16px;
      line-height: 28px;
      text-align: center;
    }
  }
}
}
.recommendList {
  margin-top: 10px;
  background-color: #ffffff;
  border:1px solid #e4e7ed ;
  .title {
    font-weight: normal !important;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 20px;
    border-bottom: 1px solid #e4e7ed;
    .name {
      color: #b79255;
      font-size: 18px;
      height: 15px;
      padding-left: 10px;
      border-left: 3px solid #b79255;
      line-height: 15px;
    }
    .more {
      cursor: pointer;
      font-size: 14px;
      color: #666666;
      display: flex;
      align-items: center;
      img {
        margin-left: 5px;
        width: 16px;
        height: 16px;
      }
    }
  }
  /deep/ .empty-data .nodata .message {
    line-height: 1;
  }
}
  .detail-item {
    display: flex;
    padding-top: 10px;
    line-height: 22px;
    // &:last-of-type {
    //   padding-bottom: 0;
    // }
    .item-name {
      flex-shrink: 0;
      color: var(--FC6);
      flex-wrap: wrap;
      max-width: 162px;
    }
    .item-value {
      color: var(--FC3);
      .item-video {
        position: relative;
        display: inline-block;
        width: 150px;
        height: 100px;
        cursor: pointer;
        > video {
          width: 100%;
          height: 100%;
        }
        &:before {
          content: "";
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(calc(-50% + 10px), -50%);
          border: solid;
          border-width: 10px 15px;
          border-color: transparent transparent transparent #fff;
        }
      }
    }
    .file-item {
      .file-item-container {
        box-sizing: border-box;
        width: 236px;
        display: flex;
        padding: 10px;
        margin-right: 10px;
        background-color: #fafafa;
        font-size: 14px;
        border-radius: 4px;
        .file-icon {
          width: 33px;
          height: 40px;
        }
        .file-info {
          flex: 1;
          padding-left: 10px;
          line-height: 1.2;
          .file-name {
            margin-bottom: 10px;
            display: flex;
            color: var(--FC3);
            .fore {
              max-width: 140px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              word-break: break-all;
            }
            .back {
              flex-shrink: 0;
            }
          }
          .file-other {
            display: flex;
            justify-content: space-between;
            .file-size {
              color: var(--FC9);
            }
            .file-download {
              cursor: pointer;
              color: #0286df;
            }
          }
        }
      }
    }
  }
  /deep/ .el-tabs__item:focus.is-active.is-focus:not(:active) {
    -webkit-box-shadow: none;
    box-shadow: none;
  }
</style>
<style lang="scss" rel="stylesheet/scss">
.popperCustoms {
  padding: 5px 10px!important;
  &.is-light {
    background: #ffffff !important;
    border: 1px solid #666666;
    box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.08);
    border-radius: 0;
    opacity: 1 !important;
    color: #666666 !important;
  }
}
</style>
